// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f_7s","field":"styles_field__WvsXH","fieldCol":"styles_fieldCol__238bq","diffCol":"styles_diffCol__2SWbl","diff":"styles_diff__2m2ew"};